'use client';

import { FormSortEvent } from '@/types/forms';
import EmbedFlow from '@formsort/react-embed';
import { useCallback } from 'react';
import { useIntakeFormHooks } from '../hooks/useIntakeFormHooks';
import { useIntakeFormStepTracking } from './useIntakeFormStepTracking';

type Props = {
  client: string;
  flow: string;
  variant: string;
};

export default function GetAnEstimateClient({ client, flow, variant }: Props) {
  const { trackStep } = useIntakeFormStepTracking();

  const { handleStepCompleted: onStepCompleted, handleFlowFinalized } =
    useIntakeFormHooks();

  const handleStepCompleted = useCallback(
    async (data: FormSortEvent) =>
      onStepCompleted(data).then(() => trackStep(data)),
    [onStepCompleted, trackStep]
  );

  const handleFlowLoaded = useCallback(() => {
    sessionStorage.clear();
  }, []);

  return (
    <EmbedFlow
      clientLabel={client}
      flowLabel={flow}
      variantLabel={variant}
      embedConfig={{
        style: {
          height: '100%',
          width: '100%',
        },
      }}
      onFlowLoaded={handleFlowLoaded}
      onFlowFinalized={handleFlowFinalized}
      onStepCompleted={handleStepCompleted}
      onRedirect={() => ({ cancel: true })}
    />
  );
}
